<template>
  <Pane :value="pane.isOpen"
        temporary
        :tabs="tabs"
        v-model:current-tab="tab"
        data-locator="signing-checklist-attachment-pane"
        @input="onPaneInput"
        @closeButtonClicked="closePane"
  >
    <template #content-share-attachment>
      <SigningChecklistPaneShareAttachment />
    </template>
  </Pane>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import Pane from '@/common/Pane.vue'
import { CHANGE_PANE_TAB } from '@/store/modules/signing-checklist/action_types'
import { SET_IS_PANE_OPENED } from '@/store/modules/signing-checklist/mutation_types'

import SigningChecklistPaneShareAttachment from './SigningChecklistPaneShareAttachment.vue'

export default {
  name: 'SigningChecklistPane',
  components: { Pane, SigningChecklistPaneShareAttachment },
  computed: {
    ...mapState('signingChecklist', ['pane']),
    ...mapGetters('room', ['isCurrentUserPm']),
    tab: {
      get () {
        return this.pane.tab
      },
      set (tab) {
        this.CHANGE_PANE_TAB(tab)
      },
    },
    tabs () {
      return this.isCurrentUserPm
        ? [{ title: this.$t('common.share'), id: 'share-attachment' }]
        : []
    },
  },
  methods: {
    ...mapActions('signingChecklist', [CHANGE_PANE_TAB]),
    ...mapMutations('signingChecklist', [SET_IS_PANE_OPENED]),
    onPaneInput (value) {
      if (!value) {
        this.CHANGE_PANE_TAB('')
      }
    },
    closePane () {
      this.SET_IS_PANE_OPENED(false)
    },
  },
}
</script>
